class RelatedRecommendations extends HTMLElement {
  constructor() {
    super();
    this.content = null;
    this.unsubscribe = null;
    this.loaded = false;
  }

  get sync() {
    return window.ProductCardColorSync || {};
  }

  connectedCallback() {
    this.content = this.querySelector('[data-related-recommendations-content]');
    this.loadRecommendations();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const colorValue = this.extractColorFromVariantEvent(event);
        if (colorValue) {
          this.dataset.initialColor = colorValue;
          this.sync.applyMatchingColor?.(this, colorValue);
        }
      });
    }
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') {
      this.unsubscribe();
    }
  }

  getColorOptionNames() {
    return (this.sync.parseColorOptionNames || (() => []))(this.dataset.colorOptionNames);
  }

  getProductOptions() {
    try {
      return JSON.parse(this.dataset.productOptions || '[]');
    } catch (e) {
      return [];
    }
  }

  extractColorFromVariantEvent(event) {
    const data = event?.data || event || {};
    const variant = data.variant;
    if (!variant) return '';

    const colorNames = this.getColorOptionNames();
    const productOptions = this.getProductOptions();

    for (let index = 0; index < productOptions.length; index += 1) {
      const optionName = String(productOptions[index] || '').toLowerCase();
      const isColor = colorNames.some((name) => optionName === name || optionName.includes(name));
      if (!isColor) continue;

      const value = variant[`option${index + 1}`] || (Array.isArray(variant.options) ? variant.options[index] : '');
      if (value) return String(value).trim();
    }

    return '';
  }

  loadRecommendations() {
    const url = this.dataset.recommendationsUrl;
    if (!url || !this.content || this.loaded) return;

    this.content.innerHTML = `<div class="related-recommendations__loading" aria-hidden="true"></div>`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const markup = this.sync.extractInlineRecommendations?.(text) || '';
        if (!markup) {
          this.hidden = true;
          this.content.innerHTML = '';
          return;
        }

        this.hidden = false;
        this.content.innerHTML = markup;
        this.loaded = true;

        const headingEl = this.content.querySelector('.product-recommendations-inline__heading');
        if (headingEl && this.dataset.heading) {
          headingEl.textContent = this.dataset.heading;
        }

        requestAnimationFrame(() => {
          this.sync.applyMatchingColor?.(this, this.dataset.initialColor);
        });
      })
      .catch(() => {
        this.hidden = true;
        this.content.innerHTML = '';
      });
  }
}

if (!customElements.get('related-recommendations')) {
  customElements.define('related-recommendations', RelatedRecommendations);
}
